<aside
  class="rounded-b-2xl flex w-full items-start gap-3 bg-primary px-4 py-3 text-primary"
  role="status"
>
  <app-svg-viewer [svg]="svg"></app-svg-viewer>
  <p class="m-0 text-lg leading-6 text-white">{{ message() }}</p>
</aside>
